import React from 'react'
import { ICSModal } from '../../../../components'
import RenderActions from '../ResultsCellRender/RenderActions'
import ICSErrorCard from '../../../../components/ICSErrorCard/ICSErrorCard'
import { ResultFilesDataSource } from '../../types'
import { ResultEntity } from '../../../../types/results'
import { getFileSize } from '../../../../utils/helpers'
import ICSDataGrid from '../../../../components/ICSDataGrid/ICSDataGrid'
import { ModalBody } from 'reactstrap'

export const resultFilesDataSource = (data: ResultEntity) => {
  const dataSource: ResultFilesDataSource = []

  if (Object.keys(data).length > 0) {
    for (let i = 0; i < data.files.length; i++) {
      const file = data.files[i]
      //TODO: fix url below
      const hrefUrl = `../dataspy/?ipaResultFileId=${file.id}&ipaResultId=${data.id}`

      dataSource.push({
        name: file.filename,
        size: getFileSize(file.size),
        dataSpy: hrefUrl,
        resultFileId: file.id,
      })
    }
  }

  return dataSource
}

const ResultFilesModal = ({
  selectedResult,
  resultsError,
  toggleModal,
  show,
}) => {
  return (
    <ICSModal
      visible={show}
      onHiding={toggleModal}
      dragEnabled={false}
      closeOnOutsideClick={true}
      title={'Result Files'}
      defaultWidth={'75vw'}
      defaultHeight={'auto'}
      id='ResultFilesModal'
    >
        <ModalBody>
        {resultsError?.code === 'error' && show ? (
          <div>
            <ICSErrorCard
              code={resultsError.code}
              message={resultsError.message}
              fields={resultsError.fields}
              title={'Error Downloading Result File'}
            />
          </div>
        ) : (
          <div>
            <ICSDataGrid
              dataSource={resultFilesDataSource(selectedResult)}
              columnOptions={[
                {
                  dataField: 'name',
                  caption: 'Name',
                },
                {
                  dataField: 'size',
                  caption: 'Size',
                },
                {
                  dataField: 'dataSpy',
                  caption: 'Actions',
                  cellRender: e => <RenderActions e={e} />,
                },
              ]}
            />
          </div>
        )}
        </ModalBody>
    </ICSModal>
  )
}

export default ResultFilesModal
